import { isNullOrUndefined } from '@coveo/bueno';
import { createSelector } from '@reduxjs/toolkit';
import { stateKey } from '../../../app/state-key.js';
import { totalEntriesPrincipalSelector } from '../pagination/pagination-selectors.js';
/**
 * Duplicate selector since the state is no longer accessible externally
 * TODO: KIT-3199: Update all other selectors to use the engine as a parameter
 */
export const responseIdSelectorFromEngine = (engine) => engine[stateKey].productListing.responseId;
export const responseIdSelector = (state) => state.productListing.responseId;
export const requestIdSelector = (state) => state.productListing.requestId;
export const numberOfProductsSelector = (state) => state.productListing?.results.length ||
    state.productListing?.products.length ||
    0;
export const moreProductsAvailableSelector = createSelector((state) => ({
    total: totalEntriesPrincipalSelector(state),
    current: numberOfProductsSelector(state),
}), ({ current, total }) => current < total);
export const isLoadingSelector = (state) => {
    const isLoading = state.productListing?.isLoading;
    return isNullOrUndefined(isLoading) ? false : isLoading;
};
export const errorSelector = (state) => state.productListing?.error ?? null;
